module.exports = __webpack_public_path__ + "static/media/04s.025adfa0.png";